<div class="card image-card" *ngIf="isImage">
    <img [src]="fileUrl" />
    <div class="card-body">
        <span class="text" title="{{attachment.name}}">{{attachment.name}}</span>
        
        <fa-icon [icon]="faDownload"
                 (click)="download($event)"></fa-icon>
    </div>
</div>
